// extracted by mini-css-extract-plugin
export var button = "_cf-4";
export var hasDarkBackground = "_cf-7";
export var hasLightBackground = "_cf-6";
export var iconWrapper = "_cf-0";
export var large = "_cf-2";
export var medium = "_cf-1";
export var small = "_cf-5";
export var xsmall = "_cf-3";